import React from 'react'
import { windowStates } from 'catena/er2_map_userlayers/js/components/window_state'
import TabbedPanel from 'catena/er2_map_userlayers/js/components/tabbed_panel'

const RefugeeModelTabs = (props) => {
    const onSel = (key) => {
    }
    const children = props.children
    if (children) {
        if (children.map === undefined) {
            // One child, don't show tab
            const C = children
            const rootClassNames = [props.theme.analysisPanel]
            rootClassNames.push(props.tocVisible ? props.theme.contextBarOpen : props.theme.contextBarClosed)
            rootClassNames.push(props.theme.mapToolbarPanelClosed)
            if (props.tabbedPanel.windowState === windowStates.maximized) rootClassNames.push(props.theme.headerPanelOpen)

            return (
                <div
                    className={rootClassNames.join(' ')}
                >
                    <C.type
                        {...C.props}
                        key={C.key}
                    />
                </div>
            )
        }
        return (
            <TabbedPanel
                {...props}
                scrollable={false}
                onSetTabbedPanel={onSel}
            >
                {children.map(C => (
                    <C.type
                        {...C.props}
                        key={C.key}
                    />
                ))}
            </TabbedPanel>
        )
    }
    return (null)
}

export default RefugeeModelTabs
